import React, { FC } from 'react'
import './ModalContactForm.scss'
import { Modal } from 'react-bootstrap'
import Information from 'app_components/screens/landing/ContactForm/Components/Information'

interface IModalContactFormProps {
  onClose: (saved?: boolean) => void
  open: boolean
  defaultMessage?: string
}

const ModalContactForm: FC<IModalContactFormProps> = ({
  onClose,
  open,
  defaultMessage,
}) => {
  const handleCloseModal = () => {
    onClose()
  }

  return (
    <Modal
      show={open}
      onHide={handleCloseModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Estoy interesado
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Information
          buttonClose={handleCloseModal}
          hideTitle
          hideCloseIcon
          containerStyles={{
            backgroundColor: 'transparent',
            paddingTop: '0px'
          }}
          labelTextColor='var(--text3)'
          defaultMessage={defaultMessage}
          buttonText='Enviar'
        />
      </Modal.Body>
    </Modal>
  )
}

export default ModalContactForm
